import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsJoinNowModalWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";

class RewardsJoinNowModalWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug("RewardsJoinNowModalWidgetInjector start", {
            placeholderSelector: this.config.placeholderSelector,
        });

        const widgetName = REWARDS_WIDGET_NAMES.REWARDS_JOIN_NOW_MODAL_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsJoinNowModalWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsJoinNowModalWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsJoinNowModalWidgetDefinition,
                        true
                    );

                const widget = new RewardsJoinNowModalWidget(
                    {
                        target: placeholder,
                    },
                    this.config.logger
                );

                await widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsJoinNowModalWidgetInjector;
